import palette from "src/theme/palette";
import ChatIcon from "src/icons/notifications/ChatIcon";
import VoiceIcon from "src/icons/notifications/VoiceIcon";
import BuildIcon from "src/icons/notifications/BuildIcon";
import PublishIcon from "src/icons/notifications/PublishIcon";
import { NOTIFICATION_STATUSES, NOTIFICATION_TYPES } from "../notifications.consts";
import { ASSISTANT_CHANNELS } from "@consts";

export const STATUS_DISPLAY_TEXT = {
  [NOTIFICATION_STATUSES.IN_PROGRESS]: "In Progress",
  [NOTIFICATION_STATUSES.COMPLETED]: "Completed",
  [NOTIFICATION_STATUSES.FAILED]: "Failed",
  [NOTIFICATION_STATUSES.CANCELED]: "Canceled",
};

export const STATUS_STYLES = {
  [NOTIFICATION_STATUSES.IN_PROGRESS]: {
    background: palette.info[200],
    color: palette.info[600],
    borderColor: palette.system[200],
  },
  [NOTIFICATION_STATUSES.COMPLETED]: {
    background: palette.success[200],
    color: palette.success[700],
    borderColor: palette.success[400],
  },
  [NOTIFICATION_STATUSES.FAILED]: {
    background: palette.error[100],
    color: palette.error[600],
    borderColor: palette.error[300],
  },
  [NOTIFICATION_STATUSES.CANCELED]: {
    background: palette.warning[200],
    color: palette.warning[700],
    borderColor: palette.warning[400],
  },
};

export const TYPE_CONFIGS = {
  [NOTIFICATION_TYPES.PREVIEW]: {
    title: "Preparing Preview",
    messages: {
      [NOTIFICATION_STATUSES.IN_PROGRESS]: "Preview is being prepared. You'll be able to test it once ready.",
      [NOTIFICATION_STATUSES.COMPLETED]: "Preparation is completed you can now test the agent.",
      [NOTIFICATION_STATUSES.FAILED]: "Preparing preview failed to complete. Please try again or contact support.",
      [NOTIFICATION_STATUSES.CANCELED]: "Preparing preview was canceled by the user.",
    },
  },
  [NOTIFICATION_TYPES.BUILD]: {
    title: "Build Process",
    messages: {
      [NOTIFICATION_STATUSES.IN_PROGRESS]: "The build process has started and is in progress.",
      [NOTIFICATION_STATUSES.COMPLETED]: "Build succeeded. The agent is ready for testing and publishing.",
      [NOTIFICATION_STATUSES.FAILED]: "Build failed to complete. Please try again or contact support.",
      [NOTIFICATION_STATUSES.CANCELED]: "Build process was canceled by the user.",
    },
  },
  [NOTIFICATION_TYPES.PUBLISH]: {
    title: "Publishing Changes",
    messages: {
      [NOTIFICATION_STATUSES.IN_PROGRESS]: "Publishing is in progress. Your changes will update soon.",
      [NOTIFICATION_STATUSES.COMPLETED]: "Publishing is complete. Your changes are now updated.",
      [NOTIFICATION_STATUSES.FAILED]: "Publishing failed to complete. Please try again or contact support.",
      [NOTIFICATION_STATUSES.CANCELED]: "Publishing was canceled. No updates have been made.",
    },
  },
};

export const getIcon = (type, channel) => {
  switch (type) {
    case NOTIFICATION_TYPES.PREVIEW:
      return channel === ASSISTANT_CHANNELS.WEB ? ChatIcon : VoiceIcon;
    case NOTIFICATION_TYPES.BUILD:
      return BuildIcon;
    case NOTIFICATION_TYPES.PUBLISH:
      return PublishIcon;
    default:
      return null;
  }
};
